export function sellerAssociationAuthorization2026() {
return [   // Release 2025-12-19 17:05:28
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 180.8,
   left: 151.2,
   width: 180.12,
   height: 10.953
}
,
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 205.4,
   left: 151.56,
   width: 425.28,
   height: 10.953
}
,
{
   page: 0,
   name: "Seller 1 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 228.68,
   left: 151.2,
   width: 180.12,
   height: 10.953
}
,
{
   page: 0,
   name: "Seller 2 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 228.68,
   left: 367.2,
   width: 180.12,
   height: 10.953
}
,
{
   page: 0,
   name: "Authorized Agent 1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 249.56,
   left: 151.2,
   width: 180.12,
   height: 10.953
}
,
{
   page: 0,
   name: "Authorized Agent 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 272.48,
   left: 151.2,
   width: 180.12,
   height: 10.953
}
,
{
   page: 0,
   name: "Association 1 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 307.04,
   left: 140.4,
   width: 262.92,
   height: 10.953
}
,
{
   page: 0,
   name: "Manager", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 330.56,
   left: 122.52,
   width: 208.80,
   height: 10.953
}
,
{
   page: 0,
   name: "Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 330.56,
   left: 399.96,
   width: 147.36,
   height: 10.953
}
,
{
   page: 0,
   name: "Account", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 353.96,
   left: 128.28,
   width: 131.04,
   height: 10.953
}
,
{
   page: 0,
   name: "Seller Email Address on Acct", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 353.96,
   left: 390.84,
   width: 156.48,
   height: 10.953
}
,
{
   page: 0,
   name: "Seller Username Association 1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 377.48,
   left: 153.24,
   width: 142.08,
   height: 10.953
}
,
{
   page: 0,
   name: "Seller Password Association 1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 377.48,
   left: 403.08,
   width: 144.24,
   height: 10.953
}
,
{
   page: 0,
   name: "Checkbox I have not yet established an online account and authorize Authorized Agent to initiate one on my behalf", 
   isText: false,
   type: "checkbox",
   top: 404.76,
   left: 79.2,
   width: 7.8,
   height: 6.96
}
,
{
   page: 0,
   name: "Association 2 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 425.0,
   left: 140.4,
   width: 262.92,
   height: 10.953
}
,
{
   page: 0,
   name: "Manager_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 448.52,
   left: 122.52,
   width: 208.80,
   height: 10.953
}
,
{
   page: 0,
   name: "Phone_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 448.52,
   left: 399.96,
   width: 147.36,
   height: 10.953
}
,
{
   page: 0,
   name: "Account_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 471.92,
   left: 128.28,
   width: 131.04,
   height: 10.953
}
,
{
   page: 0,
   name: "Seller Email Address on Acct_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 471.92,
   left: 390.84,
   width: 156.48,
   height: 10.953
}
,
{
   page: 0,
   name: "Seller Username_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 495.44,
   left: 153.24,
   width: 142.08,
   height: 10.953
}
,
{
   page: 0,
   name: "Seller Password_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 495.44,
   left: 403.08,
   width: 144.24,
   height: 10.953
}
,
{
   page: 0,
   name: "CheckI have not yet established an online account and authorize Authorized Agent to initiate one on my behalf_2", 
   isText: false,
   type: "checkbox",
   top: 522.72,
   left: 79.2,
   width: 7.8,
   height: 6.96
}
,
{
   page: 0,
   name: "Association 3 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 542.96,
   left: 140.4,
   width: 262.92,
   height: 10.953
}
,
{
   page: 0,
   name: "Manager_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 566.48,
   left: 122.52,
   width: 208.80,
   height: 10.953
}
,
{
   page: 0,
   name: "Phone_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 566.48,
   left: 399.96,
   width: 147.36,
   height: 10.953
}
,
{
   page: 0,
   name: "Account_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 589.88,
   left: 128.28,
   width: 131.04,
   height: 10.953
}
,
{
   page: 0,
   name: "Seller Email Address on Acct_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 589.88,
   left: 390.84,
   width: 156.48,
   height: 10.953
}
,
{
   page: 0,
   name: "Seller Username_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 613.4,
   left: 153.24,
   width: 142.08,
   height: 10.953
}
,
{
   page: 0,
   name: "Seller Password_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 613.4,
   left: 403.08,
   width: 144.24,
   height: 10.953
}
,
{
   page: 0,
   name: "I have not yet established an online account and authorize Authorized Agent to initiate one on my behalf_3", 
   isText: false,
   type: "checkbox",
   top: 640.68,
   left: 79.2,
   width: 7.8,
   height: 6.96
}
,
{
   page: 0,
   name: "Association 4 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 660.92,
   left: 140.4,
   width: 262.92,
   height: 10.953
}
,
{
   page: 0,
   name: "Manager_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 684.44,
   left: 122.52,
   width: 208.80,
   height: 10.9527
}
,
{
   page: 0,
   name: "Phone_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 684.44,
   left: 399.96,
   width: 147.36,
   height: 10.9527
}
,
{
   page: 0,
   name: "Account_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 707.84,
   left: 128.28,
   width: 131.04,
   height: 10.9527
}
,
{
   page: 0,
   name: "Seller Email Address on Acct_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 707.84,
   left: 390.84,
   width: 156.48,
   height: 10.9527
}
,
{
   page: 1,
   name: "Seller Username_4", 
   isText: false,
   type: "checkbox",
   top: 74.68,
   left: 79.2,
   width: 9.9906,
   height: 10.49
}
,
{
   page: 1,
   name: "Seller Username Association 4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 51.04,
   left: 153.24,
   width: 142.08,
   height: 10.473
}
,
{
   page: 1,
   name: "Seller Password Association 4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 51.04,
   left: 403.08,
   width: 144.24,
   height: 10.473
}
,
{
   page: 1,
   name: "Radiobutton SellerCorrectMailingAddressProvidedToAssociation Have", 
   isText: false,
   type: "checkbox",
   top: 235.32,
   left: 318.0,
   width: 9.991,
   height: 9.835
}
,
{
   page: 1,
   name: "Radiobutton SellerCorrectMailingAddressProvidedToAssociation Have Not", 
   isText: false,
   type: "checkbox",
   top: 235.32,
   left: 351.6,
   width: 9.991,
   height: 9.835
}
,
{
   page: 1,
   name: "Radiobutton SellerReceivedConstructionDefectDocuments Has", 
   isText: false,
   type: "checkbox",
   top: 265.16,
   left: 117.96,
   width: 9.991,
   height: 9.835
}
,
{
   page: 1,
   name: "Radiobutton SellerReceivedConstructionDefectDocuments Has Not", 
   isText: false,
   type: "checkbox",
   top: 265.16,
   left: 147.72,
   width: 9.991,
   height: 9.835
}
] }
